var exports = {
  "AS": "xfd349460--db34da--item",
  "Pf": "xfd349460--db34da--label",
  "O0": "xfd349460--db34da--rating",
};

module.exports = exports;
